import React from 'react';
import { Link } from 'react-router-dom';
import TextareaAutosize from 'react-textarea-autosize';
import { Button, FormGroup, Input, Col, Row, Container, Label } from 'reactstrap';
import _ from 'lodash'
import api from '../../api';
import utils from '../../resources/utils';
import DataRow from '../DataRow';
import Segment from '../Segment';
import './index.css';

// The Roster component matches one of two different routes
// depending on the full pathname

export default class ActionEdit extends React.Component {
    constructor(props) {
        super(props);
        let defaultNotification = {
            title: '',
            content: '',
        };
        if (this.props.notification) {
            defaultNotification = this.props.notification;
        }
        this.state = {
            notification: defaultNotification,
            maxTitleLength: 30,
        };
    }
    componentWillMount() {}
    componentDidMount() {}
    saveNotification() {
        const { notification } = this.state;
        const { onSave } = this.props;
        if (onSave) {
            onSave(notification);
        }
    }
    updateAttr(attribute, value) {
        const { notification } = this.state;
        notification[attribute] = value;
        
        // const STATIC_CONTENT_OPTIONS = ['fav_forum']
        // const STATIC_RANKING_OPTIONS = ['top_likes', 'top_views', 'top_comments', 'top_ratings'];

        // Set notification external payload
        // if (notification.content_option) {
        //     let external_payload = {}
        //     // if (STATIC_OPTIONS.indexOf(notification.content_option) < 0) {
        //     //     external_payload.notification_type = `${notification.content_option}_${notification.content_id}`;
        //     // } else {
        //     //     notification.content_id = null;
        //     //     external_payload.notification_type = `${notification.screen}`;
        //     // }
        //     notification.data = external_payload;
        // }
        
        this.setState({ notification }, this.saveNotification);
    }
    render() {
        const {
            notification,
            maxTitleLength,
        } = this.state;
        if (!notification) return null;
        return (
            <div className="notification-edit-container">
                <h4>Dynamic Notification Content</h4>
                <p className="notification_userguide">
                    Config dynamic contents for users in this segment
                </p>
                <FormGroup>
                    <Label>Select content options</Label>
                    <p className="notification_userguide">
                        Chọn option để lấy content thích hợp cho users trong segment
                    </p>
                    <Input
                        type="select"
                        value={notification.content_option}
                        onChange={(e) => this.updateAttr('content_option', e.target.value)}
                    >
                        <option value="">--- Select an option ---</option>
                        <option value="dynamic_most_favorite_forums">Most favorite forum</option>
                    </Input>
                </FormGroup>
                <FormGroup>
                    <Label>Select ranking options</Label>
                    <p className="notification_userguide">
                        Chọn option để lấy content thích hợp cho content option
                    </p>
                    <Input
                        type="select"
                        value={notification.content_ranking}
                        onChange={(e) => this.updateAttr('content_ranking', e.target.value)}
                    >
                        <option value="">--- Select an option ---</option>
                        <option value="top_likes">Top likes content</option>
                        <option value="top_views">Top views content</option>
                        <option value="top_comments">Top comments content</option>
                        <option value="top_ratings">Top ratings content</option>
                    </Input>
                </FormGroup>
                <FormGroup>
                    <Label>Select time range</Label>
                    <p className="notification_userguide">
                        Chọn time range để lấy content ranking trong khoảng thời gian (days)
                    </p>
                    <Input 
                        type="number"
                        value={notification.time_range}
                        onChange={(e) => this.updateAttr('time_range', e.target.value)}
                    />
                </FormGroup>
                <FormGroup>
                    <Label>
                        <span>Title</span>
                        {notification && notification.title.length > maxTitleLength &&
                            <span className="notification_title_error">
                                You exceeded the maximum 30 of text characters!!
                            </span>
                        }
                    </Label>
                    <p className="notification_userguide">
                        <text>Support param: {` {{ user_name | default: 'bạn' }} \n`} </text>
                    </p>
                    <p className="notification_userguide">
                        Lưu ý: vì mỗi user sẽ nhận content khác nhau nên title nên được đặt general.
                    </p>
                    <Input
                        type="text"
                        value={notification.title}
                        placeholder="Title of notification"
                        onChange={(e) => this.updateAttr('title', e.target.value)}
                    />
                </FormGroup>
                <FormGroup>
                    <Label>Content</Label>
                    <p className="notification_userguide">
                        Support param: {`{{content_title}}`}
                    </p>
                    <Input
                        type="text"
                        value={notification.content}
                        placeholder="Customize content"
                        onChange={(e) => this.updateAttr('content', e.target.value)}
                    />
                </FormGroup>
            </div>
        );
    };
}



// WEBPACK FOOTER //
// ./src/components/DynamicNotificationEdit/index.js